<template>
  <footer>
    <div class="footer">
      <div class="content">
          <div class="address">
            <h3 class="title"><span>泉州艾奇科技有限公司  </span><span> Quanzhou Icheer Technology Co., Ltd.</span></h3>
            <ul>
              <li><b>艾奇总部</b>： 福建省泉州市丰泽区体育街华创园B515,C502,D509室</li>
              <li><b>联系电话</b>： 0595-22770778</li>
              <li><b>深圳办事处</b>： 深州市南山区留仙大道4168号众冠时代广场A座3108-3111</li>
              <li><b>联系电话</b>： 0755-26913270</li>
            </ul>
          </div>
          <div class="email">
            <h3 class="title"><span>公司邮箱</span><span>Contact Email</span></h3>
            <ul>
              <li><b>人才招聘</b>： hr@eiker.com.cn</li>
              <li><b>业务咨询</b>： icheer@eiker.com.cn</li>
              <li><b>技术服务</b>： icheertech@eiker.com.cn</li>
            </ul>
          </div>
          <div class="kefu">
            <img src="https://website.obs.icheer.cn/icheer-web/images/qrcode/kefu.jpg" alt="">
            <div class="qrcode-text">合作咨询</div>
          </div>
          <div class="official">
            <img src="https://website.obs.icheer.cn/icheer-web/images/qrcode/icheer-wechat-qrCode.jpg" alt="">
            <div class="qrcode-text" >官方公众号</div>
          </div>
      </div>

      <div class="footer-line-icp">
        <div class="footer-div-hr">
          <hr class="footer-hr"/>
        </div>
        <div class="footer-icp">
          <span class="footer-icp">Copyright 2023 Icheer. All Rights Reserved. 艾奇科技 版权所有 闽ICP备<a href="https://beian.miit.gov.cn" style="text-decoration: none">19023234</a>号-5</span>
          <img src="https://website.obs.icheer.cn/icheer-web/images1/footer/beian.png" style="margin-left:20px;vertical-align:middle;"/><span style="margin: 0px 0px 0px 5px;">闽公网安备 35050302000832号</span>
        </div>
      </div>
    </div>
    <!-- 手机适配   -->
    <div class="footer-mobile">
      <div class="content">
        <div class="text">
           <img src="https://website.obs.icheer.cn/icheer-web/images1/footer/info.png"/>
        </div>
        <div class="qrcode">
          <img src="https://website.obs.icheer.cn/icheer-web/images1/footer/service.jpg" alt="" >
          <div class="qrcode-text">合作咨询</div>
          <img src="https://website.obs.icheer.cn/icheer-web/images1/footer/icheer-wechat-qrCode.jpg" alt="">
          <div class="qrcode-text">官方公众号</div>
        </div>
      </div>

      <div class="footer-div-hr">
        <hr class="footer-hr"/>
      </div>
      <div class="footer-icp">
        <div>Copyright 2023 Icheer. All Rights Reserved. 艾奇科技 版权所有</div>
        <div>
          "闽ICP备
          <a href="https://beian.miit.gov.cn">19023234</a>
          "号-5&nbsp;&nbsp;&nbsp;闽公网安备 35050302000832号"
        </div>
      </div>
    </div>
  </footer>
</template>
<style>

footer {
  width: 100%;
  height: 14.95vw;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 4.4vw 0 0 0;
  background-color: #f7f7f7;
  color: grey;
}

.footer{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.footer-mobile{
  width: 100%;
  height: 100%;
  display: none;
  flex-direction: column;
  align-items: center;
  margin: 0 0 0 0;
  padding: 0 0 0 0;
}

@media screen and (max-width: 768px) {
  footer {
    height: auto;
  }
  .footer{
    display: none;
  }
  .footer-mobile{
    display: flex;
    .qrcode-text{
      font-size: 2vw;
    }
  }
}

.footer .content {
  margin: 1.5vw 0 0 0;
  width: 62.97%;
  height: 80%;
  font-size: 0.62vw;
  display: flex;
  justify-content: center;
}

.footer .address{
  width: 43.6%;
  height: auto;
}

.footer .address .title{
  width: 21.88vw;
  border-bottom: 0.16vw solid #0253d9;
  margin: .82vw 0 0.85vw 0;
  line-height: 1.5vw;
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
  font-weight: 700;
}

.footer .email{
  width: 35.3%;
  height: auto;
}

.footer .email .title{
  width: 8.88vw;
  border-bottom: 0.16vw solid #0253d9;
  margin: .82vw 0 0.85vw 0;
  line-height: 1.5vw;
  display: flex;
  justify-content: space-between;
  white-space: nowrap;
  font-weight: 700;
}

.footer .kefu {
  width: 13.6%;
  height: auto;
  padding: unset;
}

.footer .kefu img{
  width: 4.7vw;
  height: 4.7vw;
  margin: 1.1vw 0 0 0;
}

.footer .qrcode-text {
  font-size: 0.62vw;
  margin: 0 0 0 0;
  width: 4.7vw;
  text-align: center;
}

.footer .official {
  width: 7.5%;
  height: auto;
}

.footer .official img {
  width: 4.7vw;
  height: 4.7vw;
  margin: 1.1vw 0 0 0;
}

.footer .qrcode-text{
  font-size: 0.62vw;
  margin: 0 0 0 0;
  width: 4.7vw;
  text-align: center;
}

.footer ul, li {
  list-style: none;
  margin: 0;
  padding: 0;
  height: 1.17vw;
}

h3, h4 {
  font-family: HarmonyOS_Sans_SC_Medium;
}

.content li b{
  font-family: HarmonyOS_Sans_SC_Medium;
}

.footer .footer-line-icp{
  width: 62.97%;
  height: 20%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
  margin: 0 0 2.4vw 0;
}

.footer .footer-div-hr {
  text-align: center;
  width: 100%;
}

.footer .footer-hr{
  width: 100%;
  border: 0.053vw solid #e5e5e5;
}

.footer .footer-icp{
  font-size: 0.8vw;
  text-align: center;
}

.footer .footer-icp a:link {
  color: #000;
  font-size: 0.8vw;
}

.footer-mobile .content {
  width: 67%;
  height: auto;
  margin: 0 0 0 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.footer-mobile .content .text{
  width: 75%;
}

.footer-mobile .content img {
  max-width: 100%;
  height: auto;
}

.footer-mobile .content .qrcode {
  width: 25%;
  text-align: center;
}

.footer-mobile .footer-div-hr {
  width: 64%;
}

.footer-mobile .footer-hr{
  width: 100%;
  border: 0.053vw solid #e5e5e5;
}

.footer-mobile .footer-icp {
  font-size: 1.5vw;
}

.footer-mobile .footer-icp a:link {
  color: #000;
  font-size: 1.5vw;
}
</style>
